<template>
  <div class="tw-bg-gray-50 tw-rounded-lg tw-p-3 tw-text-sm">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-1">
      <span class="tw-text-xs tw-font-semibold tw-text-gray-500 tw-uppercase tw-tracking-wide">
        Cast4all <span class="tw-font-normal tw-normal-case tw-text-gray-400">live<span v-if="status?.account"> · {{ ACCOUNT_LABELS[status.account] || status.account }}</span></span>
      </span>
      <slot name="actions" />
    </div>

    <div v-if="isFetching && !status" class="tw-flex tw-items-center tw-py-1 tw-text-gray-400">
      <span class="tw-w-4 tw-h-4 tw-border-2 tw-border-gray-300 tw-border-t-blue-400 tw-rounded-full tw-animate-spin tw-mr-2" />
      Gegevens ophalen bij Cast4all...
    </div>
    <div v-else-if="error" class="tw-text-red-600 tw-text-xs">
      {{ error.message || 'Cast4all-status ophalen mislukt' }}
    </div>
    <div v-else-if="status" class="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1">
      <span class="tw-text-gray-500">Registratie</span>
      <span class="tw-font-medium" :class="registeredClass(status.meter.status)">
        {{ status.meter.status || 'Onbekend' }}<span v-if="status.meter.polling === 'No'" class="tw-text-red-600 tw-font-normal"> · uitlezen uit</span>
      </span>
      <span class="tw-text-gray-500">Laatste uitlezing</span>
      <span class="tw-font-medium" :title="formatDateTimeNL(status.meter.last_successful_polling_on)">
        {{ status.meter.last_successful_polling_on ? formatRelativeNL(status.meter.last_successful_polling_on) : '—' }}
        <span v-if="status.meter.last_polling_result && status.meter.last_polling_result !== 'Success'" class="tw-text-red-600 tw-font-normal">({{ status.meter.last_polling_result }})</span>
      </span>
      <!-- the communicator type says what kind of meter it is -->
      <span class="tw-text-gray-500">Communicator</span>
      <span class="tw-font-medium">
        <template v-if="status.communicator">
          {{ status.communicator.type || 'Onbekend' }}
          <span :class="registeredClass(status.communicator.status)" class="tw-font-normal">· {{ status.communicator.status || 'onbekend' }}</span>
        </template>
        <template v-else-if="status.meter.api_meter">API van de omvormer</template>
        <template v-else>Geen</template>
      </span>
    </div>
    <div v-for="(msg, i) in status?.warnings ?? []" :key="i" class="tw-text-xs tw-text-amber-700 tw-mt-1">{{ msg }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatDateTimeNL, formatRelativeNL } from './formatters'
import { useC4aStatus } from './composables/useC4aStatus'

// The Cast4all state in a few rows, for the vendor column; the full panel (C4aStatus) opens in a modal.
// Same query (useC4aStatus), so opening it does not fetch again.
const props = defineProps({
  serialNumber: { type: String, required: true },
})

const { data: status, isFetching, error } = useC4aStatus(computed(() => props.serialNumber), computed(() => true))

const ACCOUNT_LABELS = { staedion: 'Staedion', solarminds: 'Solarminds' }

const registeredClass = (value) => (value === 'Registered' ? 'tw-text-green-600' : 'tw-text-red-600')
</script>
